export default {"src":"/_next/static/media/energy-dot.7c21d1d8.svg","height":15,"width":15,"blurWidth":0,"blurHeight":0};